import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api, apiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    (async () => {
      if (!sessionId) return navigate("/", { replace: true });
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        setUser(data);
        window.history.replaceState(null, "", "/app");
        navigate("/app", { replace: true });
        toast.success("Добре дошли!");
      } catch (err) {
        toast.error(apiError(err.response?.data?.detail) || "Неуспешно влизане с Google");
        navigate("/", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FDFBF7]">
      <div className="text-center">
        <Loader2 className="animate-spin text-sky-500 mx-auto" size={40} />
        <p className="text-slate-500 mt-4 font-semibold">Влизане с Google...</p>
      </div>
    </div>
  );
}
